<template>
    <div>
        <div class="textDiv">
            <span>{{statsTitle}}</span>
            <span>{{ occupy }}&nbsp;{{total}}{{ $t("teamTrackRecord.game") }}</span>
        </div>
        <div class="statsBar">
            <div class="barContent" :style="{width: occupy, 'background-color': occupyColor}">
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    total: {
      type: String,
      default: '1'
    },
    occupy: {
      type: String,
      default: '0.00%'
    },
    occupyColor: {
      type: String,
      default: '#ff5a5e'
    },
    statsTitle: {
      type: String,
      default: '--'
    }
  }
}
</script>

<style lang="sass" scoped>
.statsBar
    background-color: #dcdcdc
    width: 100%
    height: 8px
    border-radius: 4px
    .barContent
        height: 8px
        border-radius: 4px
.textDiv
    display: flex
    font-size: 14px
    color: #333333
    margin-top: 20px
    padding-bottom: 8px
    span:nth-child(1)
        width: 50%
        text-align: left
    span:nth-child(2)
        width: 50%
        text-align: right

</style>
